import { Context } from '@nuxt/types';
import SessionModule from '~/store/session';

export default async function(context: Context) {
    const session = context.container.get(SessionModule);
    const redirect = context.redirect;

    if (!session.isAuthenticatedUser) {
        await session.login();
        return redirect('/');
    }
    return true;
}
